import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBuy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M22.75 18A1.75 1.75 0 0 1 21 19.75H3A1.75 1.75 0 0 1 1.25 18V6c0-.966.784-1.75 1.75-1.75h18c.966 0 1.75.784 1.75 1.75v12Zm-1.75.25a.25.25 0 0 0 .25-.25V6a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v12c0 .138.112.25.25.25h18Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M14 11.5c.597 0 1.133.262 1.5.677a2 2 0 1 1 0 2.646A2 2 0 1 1 14 11.5ZM6 9.25a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5H6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorBuy;
